import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("hr", { class: "mt-2" })
], -1);
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-md-3" };
const _hoisted_4 = { class: "col-md-3" };
const _hoisted_5 = { class: "col-md-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("hr", { class: "mt-1" })
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_select_field = _resolveComponent("g-select-field");
    const _component_g_text_area = _resolveComponent("g-text-area");
    const _component_g_form = _resolveComponent("g-form");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: _ctx.$tc(`client.Commerce.${_ctx.cartType === 'L' ? 'OrderLists' : 'Carts'}.${_ctx.cartID ? 'Rename' : 'Create'}.Title`)
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: _ctx.cartID ? _ctx.$tc('shared.Text.Save') : _ctx.$tc('shared.Text.Create'),
                onClick: _withModifiers(_ctx.onCreate, ["stop", "prevent"]),
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["text", "onClick"]),
            _createVNode(_component_g_button, {
                text: _ctx.$tc('shared.Text.Cancel'),
                onClick: _ctx.currentWindow?.close,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["text", "onClick"])
        ]),
        default: _withCtx(() => [
            _createVNode(_component_g_form, { ref: "frmMain" }, {
                default: _withCtx(() => [
                    _createVNode(_component_g_text_field, {
                        label: "Bezeichnung",
                        "data-mode": "model",
                        "data-object": _ctx.$data,
                        "data-member": "cartNameInternal"
                    }, null, 8, ["data-object"]),
                    (_ctx.cartType === 'L')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_1,
                            _createVNode(_component_g_text_field, {
                                label: "Name 1",
                                "data-mode": "model",
                                "data-object": _ctx.$data,
                                "data-member": "addresses.delivery.name1",
                                "validation-rules": { required: true }
                            }, null, 8, ["data-object"]),
                            _createVNode(_component_g_text_field, {
                                label: "Name 2",
                                "data-mode": "model",
                                "data-object": _ctx.$data,
                                "data-member": "addresses.delivery.name2"
                            }, null, 8, ["data-object"]),
                            _createVNode(_component_g_text_field, {
                                label: "Zusatz",
                                "data-mode": "model",
                                "data-object": _ctx.$data,
                                "data-member": "addresses.delivery.addition"
                            }, null, 8, ["data-object"]),
                            _createVNode(_component_g_text_field, {
                                label: "Straße",
                                "data-mode": "model",
                                "data-object": _ctx.$data,
                                "data-member": "addresses.delivery.street",
                                "validation-rules": { required: true }
                            }, null, 8, ["data-object"]),
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_g_select_field, {
                                        label: "Land",
                                        "data-mode": "model",
                                        "data-object": _ctx.$data,
                                        "data-member": "addresses.delivery.country",
                                        "item-source": [{ name: 'DE', caption: 'Deutschland' }],
                                        "value-expr": "name",
                                        "display-expr": "caption"
                                    }, null, 8, ["data-object"])
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_g_text_field, {
                                        label: "Plz",
                                        "data-mode": "model",
                                        "data-object": _ctx.$data,
                                        "data-member": "addresses.delivery.zipCode",
                                        "update-lazy": true,
                                        "validation-rules": { required: true }
                                    }, null, 8, ["data-object"])
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_g_text_field, {
                                        label: "Ort",
                                        "data-mode": "model",
                                        "data-object": _ctx.$data,
                                        "data-member": "addresses.delivery.city",
                                        "validation-rules": { required: true }
                                    }, null, 8, ["data-object"])
                                ])
                            ]),
                            _hoisted_6,
                            _createVNode(_component_g_text_area, {
                                rows: 5,
                                label: "Bemerkung",
                                "data-mode": "model",
                                "data-object": _ctx.$data,
                                "data-member": "comment"
                            }, null, 8, ["data-object"])
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 512)
        ]),
        _: 1
    }, 8, ["title"]));
}
